"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRouterDom = require("react-router-dom");

var _reactRedux = require("react-redux");

var _CsvReader = _interopRequireDefault(require("./CsvReader"));

var _semanticUiReact = require("semantic-ui-react");

var _FileUploadInformation = _interopRequireDefault(require("../../components/CampaignCreator/FileUploadInformation"));

var _InlineSvg = _interopRequireDefault(require("../../../components/InlineSvg"));

var _actions = require("../../actions");

var _helpers = require("../../../helpers");

var _csvSample = _interopRequireDefault(require("../../../../pdfpages/csvSample.csv"));

var _csvSampleNZ = _interopRequireDefault(require("../../../../pdfpages/csvSampleNZ.csv"));

var _communities = require("../../reducers/communities");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

// $FlowFixMe
// $FlowFixMe
function CSVHandler(_ref) {
  var setSelectedPersonas = _ref.setSelectedPersonas,
      children = _ref.children;
  var dispatch = (0, _reactRedux.useDispatch)(); //TODO: Fix flow type
  // $FlowFixMe

  var uploadRef = (0, _react.useRef)(null);

  var _useState = (0, _react.useState)(''),
      error = _useState[0],
      setError = _useState[1];

  var _useSelector = (0, _reactRedux.useSelector)(function (state) {
    return state.selectedPersonas;
  }),
      selectedPersonas = _useSelector.personas;

  var personaIdList = (0, _reactRedux.useSelector)(_communities.getPersonaIds); // persona ID's that fall under the other category

  var otherPersonaIds = (0, _helpers.isNZHelix)() ? ['701', '702'] : ['701']; // get the full list used to check that the ID can be set on initial import

  var fullPersonaIdList = [].concat(personaIdList, otherPersonaIds);
  var papaparseOptions = {
    dynamicTyping: true,
    skipEmptyLines: 'greedy'
  };

  var handleOnDrop = function handleOnDrop(data) {
    setError(null);

    try {
      var dirtyData = [];
      var emptyData = [];
      var personasData = [];
      var personasAdded = [];
      var duplicatePersonas = []; // remove any columns that don't contain readable data

      var cleanData = data.map(function (entry) {
        Object.keys(entry.data).forEach(function (key) {
          if (entry.data[key] === null || entry.data[key] === undefined) {
            delete entry.data[key];
          }
        });
        return entry;
      }); // split data into good and bad based on what the first column contains and if the value is > 0

      cleanData.forEach(function (entry, i) {
        var idToCheck = entry.data[0].toString().trim().includes(' ') ? entry.data[0].trim().split(' ')[0] : entry.data[0];
        var value = entry.data[1]; // check if first entry in data array contains a valid persona id

        if (!fullPersonaIdList.includes(idToCheck.toString())) {
          // if it's the first index, it will be the header so move on
          if (i === 0) return; // if not, add to bad data array and return

          dirtyData.push(entry);
          return; // check if the entry is a duplicate
        } else if (personasAdded.includes(idToCheck)) {
          duplicatePersonas.push(idToCheck);
          return;
        } // check if value is 0, do not add if so


        if (parseFloat(value) <= 0) {
          emptyData.push(idToCheck);
          return;
        } // otherwise, push to personas array


        personasAdded.push(idToCheck);
        return personasData.push({
          id: entry.data[0],
          value: value
        });
      }); //TODO: Check this filtering of non number values

      var filteredData = personasData.filter(function (entry) {
        return !isNaN(parseFloat(entry.value));
      }); // get sum of all values

      var totalPersonaCount = filteredData.reduce(function (total, entry) {
        return total += parseFloat(entry.value);
      }, 0); // normalize out of 100

      var _personas = filteredData.map(function (entry) {
        return {
          id: parseInt(entry.id, 10),
          value: parseFloat(entry.value) / totalPersonaCount * 1000 / 10
        };
      }) // need to remove 701 before setting selected personas
      .filter(function (persona) {
        return !otherPersonaIds.includes(persona.id.toString());
      });

      var fileName = uploadRef.current && uploadRef.current.state && uploadRef.current.state.file && uploadRef.current.state.file.name;
      dispatch(setSelectedPersonas(_personas));
      dispatch((0, _actions.setFileUploadMeta)({
        fileName: fileName,
        dirtyData: dirtyData,
        personasAdded: personasAdded,
        duplicatePersonas: duplicatePersonas,
        emptyData: emptyData
      }));
    } catch (error) {
      setError(error.message);
    }
  };

  var handleOnError = function handleOnError(err, file, inputElem, reason) {
    setError(err);
  };

  var handleOnRemoveFile = function handleOnRemoveFile(data) {
    setError(null);
  };

  var setPreviewState = function setPreviewState() {
    dispatch((0, _actions.setPreviewSelectedPersonas)(true));
  };

  return /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid, null, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid.Row, {
    columns: 2
  }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid.Column, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "csv-handler__info-box"
  }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Icon, {
    className: "csv-handler__info-icon",
    name: "info circle",
    size: "large"
  }), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("p", null, "Your upload file should be in CSV format, with two columns. Your column headers can be anything, but your first column must contain Helix Personas, with non-formatted values in the second column. The values can be any units, but will be used to infer a percentage distribution. You do not need to include all personas, however note that your your total addressable audience will be defined as those personas included."), /*#__PURE__*/_react["default"].createElement("p", null, "You can download a sample file by clicking the link below."))), /*#__PURE__*/_react["default"].createElement("h2", null, "File Layout Example"), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Table, {
    size: "small",
    compact: "very",
    celled: true,
    className: "csv-handler__example-table"
  }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Table.Header, null, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Table.Row, null, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Table.HeaderCell, null, "Persona"), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Table.HeaderCell, null, "Percentage"))), (0, _helpers.isNZHelix)() ? /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Table.Body, null, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Table.Row, null, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Table.Cell, null, "101 Bluechip"), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Table.Cell, null, "4.5")), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Table.Row, null, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Table.Cell, null, "102 Smart Money"), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Table.Cell, null, "2.3")), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Table.Row, null, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Table.Cell, null, "103 Financial Freedom"), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Table.Cell, null, "2.4")), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Table.Row, null, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Table.Cell, null, "104 Self-made Lifestylers"), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Table.Cell, null, "0.8")), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Table.Row, null, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Table.Cell, null, "105 Worldly and Wise"), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Table.Cell, null, "2.5")), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Table.Row, null, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Table.Cell, null, "106 Status Matters"), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Table.Cell, null, "2.7")), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Table.Row, null, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Table.Cell, null, "107 Savvy Self-starters"), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Table.Cell, null, "4"))) : /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Table.Body, null, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Table.Row, null, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Table.Cell, null, "101 Bluechip"), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Table.Cell, null, "4.5")), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Table.Row, null, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Table.Cell, null, "102 Smart Money"), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Table.Cell, null, "2.3")), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Table.Row, null, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Table.Cell, null, "103 Social Progressives"), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Table.Cell, null, "2.4")), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Table.Row, null, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Table.Cell, null, "104 Having It All"), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Table.Cell, null, "0.8")), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Table.Row, null, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Table.Cell, null, "105 Visible Success"), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Table.Cell, null, "2.5")), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Table.Row, null, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Table.Cell, null, "106 Self-Made Lifestylers"), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Table.Cell, null, "2.7")), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Table.Row, null, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Table.Cell, null, "107 Domestic Bliss"), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Table.Cell, null, "4"))))), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid.Column, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "csv-handler__output-wrapper"
  }, /*#__PURE__*/_react["default"].createElement(_FileUploadInformation["default"], {
    otherPersonaIds: otherPersonaIds
  }), /*#__PURE__*/_react["default"].createElement(_CsvReader["default"] // $FlowFixMe
  , {
    ref: uploadRef,
    onDrop: handleOnDrop,
    onError: handleOnError,
    addRemoveButton: true,
    onRemoveFile: handleOnRemoveFile,
    config: papaparseOptions,
    style: {
      borderRadius: '0px',
      'border-radius': '0px',
      border: '4px dashed #0f849e',
      background: '#E6E6E6'
    }
  }, /*#__PURE__*/_react["default"].createElement(_InlineSvg["default"], {
    name: "file",
    colour: "grey",
    className: "csv-handler__file-svg"
  }), /*#__PURE__*/_react["default"].createElement("span", {
    style: {
      paddingTop: '0.5em'
    }
  }, "Drag files here or click to browse"), /*#__PURE__*/_react["default"].createElement("span", null, ".csv only")), error && /*#__PURE__*/_react["default"].createElement("p", {
    style: {
      color: 'red'
    }
  }, error)))), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid.Row, {
    columns: 2
  }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid.Column, {
    style: {
      display: 'flex',
      justifyContent: 'space-between'
    }
  }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Button, {
    as: _reactRouterDom.Link,
    to: "getting-started"
  }, "Back"), /*#__PURE__*/_react["default"].createElement("a", {
    className: "ui inverted button find-persona--csv-link",
    href: (0, _helpers.isNZHelix)() ? _csvSampleNZ["default"] : _csvSample["default"],
    download: "csvExample.csv"
  }, "Download Example File Layout")), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid.Column, {
    style: {
      display: 'flex',
      justifyContent: 'flex-end'
    }
  }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Button, {
    as: _reactRouterDom.Link,
    className: "csv-handler__preview-button " + (selectedPersonas.length === 0 ? 'disabled ' : ''),
    to: "personas-distribution",
    onClick: setPreviewState
  }, "Preview Uploaded Profile"), children && children)));
}

var _default = CSVHandler;
exports["default"] = _default;